module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vabdo4-d80ea6493eee8e6ee6f01769888fce49.jpg";